module.exports = __webpack_public_path__ + "static/img/blank.299ab471.png";